import { Icon } from '@trlogic/ui-pack';
import React, { Component, ReactNode } from 'react';
import CustomCheckBox from '../CustomCheckBox';
import { CustomFilterCategorical, CustomFilterField, CustomFilterFields } from '../../../domain/ui/FilterDomains';

class CustomFilterCategoricalEditorComponent extends Component<Props, State> {
  public state: State = new State();

  public render(): ReactNode {
    const { searchTerm } = this.state;
    const { field, fields } = this.props;

    const items = fields.find((f) => f.key == field.field);
    const filteredItems = items?.items?.filter((item) => item.label.toLowerCase().includes(searchTerm.toLowerCase()));
    const isCheckedAll = filteredItems?.every((f) => (field.search.value as CustomFilterCategorical)?.values?.includes(f.key)) || false;

    return (
      <div className={'flex w-[420px] h-full flex-col border-b border-b-[#E0E4E8]'}>
        <div className={'flex h-[65px] items-center justify-start w-full bg-[#F9FAFB] px-5 border-b-[#E0E4E8] border-b-[1px]'}>
          <div className={'flex items-center border-[1px] border-[#E0E4E8] justify-start px-2 w-full bg-white rounded-[4px] h-[42px]'}>
            <Icon icon={'search'} size={20} />
            <input className={'border-none text-sm indent-2 outline-none bg-transparent'} onChange={(e) => this.setState({ searchTerm: e.target.value })} />
          </div>
        </div>
        <div className={'flex items-center justify-between gap-x-2 px-5 py-2 border-b mb-2'}>
          <div className={'flex items-center justify-start gap-x-2'}>
            <CustomCheckBox checked={isCheckedAll} onChangeChecked={(checked) => this.onCheckAll(checked, filteredItems)} />
            <p className={'text-sm text-f-black-2'}>Select All</p>
          </div>
        </div>
        <div className={'flex flex-col max-h-52 overflow-scroll'}>
          <ul>{this.getFields(filteredItems)}</ul>
        </div>
      </div>
    );
  }

  private getFields = (filteredItems: { label: string; key: string | boolean | number }[] | undefined): ReactNode => {
    const { field } = this.props;
    return filteredItems?.map((i) => {
      return (
        <div key={i.key + i.label} className={'flex items-center w-full h-10 gap-x-2 px-5'}>
          <CustomCheckBox
            checked={(field.search.value as CustomFilterCategorical).values.includes(i.key)}
            onChangeChecked={(checked) => this.onCheck(checked, i)}
          />
          <p className={'text-xs text-primary'}>{i.label}</p>
        </div>
      );
    });
  };

  private onCheckAll = (checked: boolean, filteredItems: { label: string; key: string | boolean | number }[] | undefined) => {
    const { field, onChange } = this.props;
    const values = field.search.value as CustomFilterCategorical;
    if (filteredItems === undefined) return;
    if (checked) {
      filteredItems.forEach((i) => {
        if (!values.values.includes(i.key)) {
          values.values.push(i.key);
        }
      });
    } else {
      filteredItems.forEach((i) => {
        const index = values.values.indexOf(i.key);
        if (index !== -1) {
          values.values.splice(index, 1);
        }
      });
    }
    onChange();
  };

  private onCheck = (checked: boolean, i: { label: string; key: string | number | boolean }) => {
    const { field, onChange } = this.props;
    const values = field.search.value as CustomFilterCategorical;
    if (checked) {
      if (!values.values.includes(i.key)) {
        values.values.push(i.key);
        onChange();
      }
    } else {
      const index = values.values.indexOf(i.key);
      if (index != -1) {
        values.values.splice(index, 1);
        onChange();
      }
    }
  };
}

class State {
  searchTerm: string = '';
}

interface Props {
  field: CustomFilterField;
  fields: CustomFilterFields[];
  onChange: () => void;
}

export default CustomFilterCategoricalEditorComponent;
